import React, { useEffect, useRef, useState } from "react";
import Layout from "../components/Layout";
import client from "../lib/api";
import { AiText, Spinner } from "../components/ui-kit";
import { Send, Coins, Bitcoin } from "lucide-react";

const SUGGEST = {
  gold: ["Gold ka next major liquidity zone kya hai?", "Gold ka 4H aur 15M trend compare karo", "What changed after CPI?", "Show today's strongest Gold setup"],
  btc: ["BTC funding rate ka kya meaning hai?", "Why is BTC falling?", "BTC open interest interpretation", "Liquidation risk right now?"],
};

export default function AIResearch({ forceAssistant, embed }) {
  const [assistant, setAssistant] = useState(forceAssistant || "gold");
  const [sessionId] = useState(() => "sess-" + Math.random().toString(36).slice(2));
  const [msgs, setMsgs] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const endRef = useRef(null);

  useEffect(() => { setMsgs([]); }, [assistant]);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [msgs, loading]);

  const send = async (text) => {
    const q = text || input;
    if (!q.trim() || loading) return;
    setInput(""); setMsgs((m) => [...m, { role: "user", text: q }]); setLoading(true);
    try {
      const { data } = await client.post("/ai/chat", { session_id: `${sessionId}-${assistant}`, message: q, assistant });
      setMsgs((m) => [...m, { role: "assistant", text: data.answer }]);
    } catch {
      setMsgs((m) => [...m, { role: "assistant", text: "AI is unavailable right now." }]);
    } finally { setLoading(false); }
  };

  const accent = assistant === "gold" ? "gold" : "btc";
  const body = (
      <div className="flex flex-col h-[calc(100vh-180px)] surface">
        {!forceAssistant && (
          <div className="flex border-b border-[color:var(--border-subtle)]">
            <button data-testid="tab-gold-ai" onClick={() => setAssistant("gold")} className={`flex-1 py-3 flex items-center justify-center gap-2 text-sm transition-colors duration-200 ${assistant === "gold" ? "text-gold border-b-2 border-gold" : "text-slate-400 hover:text-white"}`}><Coins size={16} />Gold AI</button>
            <button data-testid="tab-btc-ai" onClick={() => setAssistant("btc")} className={`flex-1 py-3 flex items-center justify-center gap-2 text-sm transition-colors duration-200 ${assistant === "btc" ? "text-btc border-b-2 border-btc" : "text-slate-400 hover:text-white"}`}><Bitcoin size={16} />Bitcoin AI</button>
          </div>
        )}

        <div className="flex-1 overflow-y-auto p-4 space-y-4">
          {msgs.length === 0 && (
            <div className="h-full flex flex-col items-center justify-center text-center px-6">
              <div className={`w-14 h-14 flex items-center justify-center mb-4 ${accent === "gold" ? "text-gold" : "text-btc"}`} style={{ background: "var(--surface-hover)" }}>
                {accent === "gold" ? <Coins size={26} /> : <Bitcoin size={26} />}
              </div>
              <h3 className="font-head text-lg text-white">{accent === "gold" ? "Gold AI" : "Bitcoin AI"} Research Assistant</h3>
              <p className="text-sm text-slate-500 mt-1 max-w-md">Ask about structure, liquidity, macro/derivatives, setups and news. Research only — no guaranteed profits.</p>
              <div className="flex flex-wrap gap-2 justify-center mt-5 max-w-xl">
                {SUGGEST[accent].map((s) => (
                  <button key={s} onClick={() => send(s)} className="text-xs px-2.5 py-1.5 border border-[color:var(--border-subtle)] text-slate-400 hover:border-gold hover:text-gold transition-colors duration-200">{s}</button>
                ))}
              </div>
            </div>
          )}
          {msgs.map((m, i) => (
            <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
              <div className={`max-w-[85%] px-4 py-3 text-sm ${m.role === "user" ? "bg-gold text-black" : "surface text-slate-200"}`}>
                {m.role === "user" ? m.text : <AiText text={m.text} />}
              </div>
            </div>
          ))}
          {loading && <div className="flex justify-start"><div className="surface px-4 py-3"><Spinner label="Analyzing" /></div></div>}
          <div ref={endRef} />
        </div>

        <form onSubmit={(e) => { e.preventDefault(); send(); }} className="p-3 border-t border-[color:var(--border-subtle)] flex gap-2">
          <input data-testid="ai-chat-input" value={input} onChange={(e) => setInput(e.target.value)} placeholder={`Ask ${accent === "gold" ? "Gold" : "Bitcoin"} AI…`}
            className="flex-1 bg-[color:var(--app-bg)] border border-[color:var(--border-subtle)] px-3 py-2.5 text-sm text-white focus:border-gold focus:outline-none transition-colors duration-200" />
          <button data-testid="ai-chat-send" disabled={loading} className="btn-gold px-4 flex items-center gap-1.5 text-sm disabled:opacity-60"><Send size={15} /></button>
        </form>
      </div>
  );
  return embed ? body : <Layout title="AI Research Assistant">{body}</Layout>;
}
